import React, { memo } from 'react';
import colors from '../../styles/_colors.module.scss';
import styles from './warningGradient.module.scss';

export default memo(function WarningGradient() {
    return (
        <svg aria-hidden="true" focusable="false" className={styles.linearGradientSVG}>
            <defs>
                <linearGradient gradientTransform="skewX(50)" id="gradient-horizontal-warning">
                    <stop offset="0%" stopColor={colors.red} />
                    <stop offset="100%" stopColor={colors.orange} />
                </linearGradient>
            </defs>
        </svg>
    );
});
